import {
  getShowDateTimeParts,
  sameShowCalendarDay,
} from "./showDates";

// Duplicate the array for whats on Component
function duplicateArray(arr, n) {
  return Array(n).fill(arr).flat();
}

function getAdelaideClockParts(today) {
  const instant = today instanceof Date ? today : new Date();
  return getShowDateTimeParts(instant);
}

function isSameShowDay(dayDate, today) {
  return sameShowCalendarDay(dayDate, today);
}

function isTimeInRange(currentHour, currentMinute, startHour, startMinute, endHour, endMinute) {
  return (
    (currentHour > startHour && currentHour < endHour) ||
    (currentHour === startHour && currentMinute >= startMinute) ||
    (currentHour === endHour && currentMinute <= endMinute)
  );
}

function isUpcomingWithinTwoHours(currentHour, currentMinute, startHour, startMinute) {
  return (
    (startHour > currentHour && startHour < currentHour + 2) ||
    (startHour === currentHour && startMinute >= currentMinute) ||
    (startHour === currentHour + 2 && startMinute <= currentMinute)
  );
}

function isMoreThanTwoHoursAway(currentHour, currentMinute, startHour, startMinute) {
  return (
    startHour > currentHour + 2 ||
    (startHour === currentHour + 2 && startMinute > currentMinute)
  );
}

// Get Live Events
export function getLiveEvents(events, today) {
  const { hour: currentHour, minute: currentMinute } =
    getAdelaideClockParts(today);

  const filteredEvents = events.filter((event) => {
    if (event?.multi_day) {
      let eventIsHappeningNow = false;
      event.days.forEach((day) => {
        if (!isSameShowDay(day.date, today)) return;

        if (day?.all_day_multi_day) {
          eventIsHappeningNow = true;
        }

        const startHour = parseInt(day?.start_time?.split(":")[0], 10);
        const startMinute = parseInt(day?.start_time?.split(":")[1], 10);
        const endHour = parseInt(day?.end_time?.split(":")[0], 10);
        const endMinute = parseInt(day?.end_time?.split(":")[1], 10);

        if (
          isTimeInRange(
            currentHour,
            currentMinute,
            startHour,
            startMinute,
            endHour,
            endMinute
          )
        ) {
          eventIsHappeningNow = true;
        }
      });
      return eventIsHappeningNow;
    }

    if (event?.all_day == true) return true;

    const startHour = parseInt(event?.start_time?.split(":")[0], 10);
    const startMinute = parseInt(event?.start_time?.split(":")[1], 10);
    const endHour = parseInt(event?.end_time?.split(":")[0], 10);
    const endMinute = parseInt(event?.end_time?.split(":")[1], 10);

    return isTimeInRange(
      currentHour,
      currentMinute,
      startHour,
      startMinute,
      endHour,
      endMinute
    );
  });

  return duplicateArray(filteredEvents, 4);
}

// Get Upcoming Events
export function getUpcomingEvents(events, today) {
  const { hour: currentHour, minute: currentMinute } =
    getAdelaideClockParts(today);

  const filteredEvents = events.filter((event) => {
    if (event?.multi_day) {
      let eventIsUpcoming = false;

      event.days.forEach((day) => {
        if (!isSameShowDay(day.date, today)) return;

        if (day?.all_day_multi_day) {
          eventIsUpcoming = false;
        }

        const startHour = parseInt(day?.start_time?.split(":")[0], 10);
        const startMinute = parseInt(day?.start_time?.split(":")[1], 10);

        if (
          isUpcomingWithinTwoHours(
            currentHour,
            currentMinute,
            startHour,
            startMinute
          )
        ) {
          eventIsUpcoming = true;
        }
      });
      return eventIsUpcoming;
    }

    if (event?.all_day == true) return false;

    const startHour = parseInt(event?.start_time?.split(":")[0], 10);
    const startMinute = parseInt(event?.start_time?.split(":")[1], 10);

    return isUpcomingWithinTwoHours(
      currentHour,
      currentMinute,
      startHour,
      startMinute
    );
  });
  return duplicateArray(filteredEvents, 4);
}

// Get Future Events
export function getFutureEvents(events, today) {
  const { hour: currentHour, minute: currentMinute } =
    getAdelaideClockParts(today);

  const filteredEvents = events.filter((event) => {
    if (event?.multi_day) {
      let eventIsInTheFuture = false;

      event.days.forEach((day) => {
        if (!isSameShowDay(day.date, today)) return;

        if (day?.all_day_multi_day) {
          eventIsInTheFuture = false;
        }

        const startHour = parseInt(day?.start_time?.split(":")[0], 10);
        const startMinute = parseInt(day?.start_time?.split(":")[1], 10);

        if (
          isMoreThanTwoHoursAway(
            currentHour,
            currentMinute,
            startHour,
            startMinute
          )
        ) {
          eventIsInTheFuture = true;
        }
      });
      return eventIsInTheFuture;
    }

    if (event?.all_day == true) return false;

    const startHour = parseInt(event?.start_time?.split(":")[0], 10);
    const startMinute = parseInt(event?.start_time?.split(":")[1], 10);

    return isMoreThanTwoHoursAway(
      currentHour,
      currentMinute,
      startHour,
      startMinute
    );
  });
  return duplicateArray(filteredEvents, 4);
}

export function convertToAmPmFormat(timeString) {
  if (!timeString) return;
  const [hours, minutes] = timeString?.split(":").map(Number);
  const date = new Date(2000, 0, 1, hours, minutes);
  const hours12 = date.getHours() % 12 || 12;
  const period = date.getHours() < 12 ? "am" : "pm";

  if (minutes === 0) {
    return `${hours12}${period}`;
  }
  return `${hours12}:${String(minutes).padStart(2, "0")}${period}`;
}

function matchDaySession(day, today, type, currentHour, currentMinute) {
  if (!isSameShowDay(day.date, today)) return false;

  const startHour = parseInt(day?.start_time?.split(":")[0], 10);
  const startMinute = parseInt(day?.start_time?.split(":")[1], 10);
  const endHour = parseInt(day?.end_time?.split(":")[0], 10);
  const endMinute = parseInt(day?.end_time?.split(":")[1], 10);

  if (type == "now") {
    return isTimeInRange(
      currentHour,
      currentMinute,
      startHour,
      startMinute,
      endHour,
      endMinute
    );
  }
  if (type == "upcoming") {
    return isUpcomingWithinTwoHours(
      currentHour,
      currentMinute,
      startHour,
      startMinute
    );
  }
  if (type == "later") {
    return isMoreThanTwoHoursAway(
      currentHour,
      currentMinute,
      startHour,
      startMinute
    );
  }
  return false;
}

// Get Event Time
export function getEventTime(event, today, type) {
  let endTime;
  let startTime;

  const { hour: currentHour, minute: currentMinute } =
    getAdelaideClockParts(today);

  if (event?.multi_day) {
    event.days.forEach((day) => {
      if (!matchDaySession(day, today, type, currentHour, currentMinute)) return;

      startTime = convertToAmPmFormat(day?.start_time);
      endTime = convertToAmPmFormat(day?.end_time);
    });
  } else if (event?.all_day) {
    return "All Day";
  } else {
    endTime = convertToAmPmFormat(event?.end_time);
    startTime = convertToAmPmFormat(event?.start_time);
  }
  if (!endTime) return `From ${startTime}`;
  return `${startTime} - ${endTime}`;
}

export function getEventTitle(event, today, type) {
  let title = event?.title;
  let description = event?.short_description;
  let image = event?.grid_image;

  const { hour: currentHour, minute: currentMinute } =
    getAdelaideClockParts(today);

  if (event?.multi_day) {
    event.days.forEach((day) => {
      if (!matchDaySession(day, today, type, currentHour, currentMinute)) return;

      if (day?.override_display_data) {
        title = day?.override_title ? day?.override_title : event?.title;
        description = day?.override_short
          ? day?.override_short
          : event?.short_description;
        image = day?.override_grid
          ? day?.override_grid
          : event?.slideshow_images[0];
      }
    });
  }
  return { title, description, image };
}
